<template>
  <div>
    <div class="p-container" v-show="!isInfoShow">
      <div class="pc-img-wrapper">
        <img class="pc-desc" :src="imgSrc" alt="">
      </div>
      <div class="pc-btn">
        <img class="pcb-l" @click="clickLeft" :src="btnSrc.btn1" alt="">
        <img class="pcb-r" @click="clickRight" :src="btnSrc.btn2" alt="">
      </div>
    </div>
    <div class="info-page slideIn" v-show="isInfoShow">
      <img class="ip-ani" :src="infoSrc.src1" alt="">
      <img class="ip-desc" :src="infoSrc.src2" alt="">
      <img class="ip-cross" @click="crossIt" src="./cross.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Prompt',
  props: {
    num: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      isInfoShow: false,
      onClickNumber: 1,
      img1: require('./p1-desc.png'),
      img2: require('./p2-desc.png'),
      img3: require('./p3-desc.png'),
      img4: require('./p4-desc.png'),
      btn11: require('./p1-btn1.png'),
      btn12: require('./p1-btn2.png'),
      btn21: require('./p2-btn1.png'),
      btn22: require('./p2-btn2.png'),
      btn31: require('./p3-btn1.png'),
      btn32: require('./p3-btn2.png'),
      btn41: require('./p4-btn1.png'),
      btn42: require('./p4-btn2.png'),
      imgSrc11: require('./circuit.gif'),
      imgSrc12: require('./p11-desc.png'),
      imgSrc21: require('./radio.gif'),
      imgSrc22: require('./p12-desc.png'),
      imgSrc31: require('./x-ray.gif'),
      imgSrc32: require('./p21-desc.png'),
      imgSrc41: require('./dna.gif'),
      imgSrc42: require('./p22-desc.png'),
      imgSrc51: require('./airplane.gif'),
      imgSrc52: require('./p31-desc.png'),
      imgSrc61: require('./spacecraft.gif'),
      imgSrc62: require('./p32-desc.png'),
      imgSrc71: require('./microscope.gif'),
      imgSrc72: require('./p41-desc.png'),
      imgSrc81: require('./telescope.gif'),
      imgSrc82: require('./p42-desc.png'),
    }
  },
  computed: {
    btnSrc () {
      switch (this.num) {
        case 1:
          return {
            btn1: this.btn11,
            btn2: this.btn12
          }
        case 2:
          return {
            btn1: this.btn21,
            btn2: this.btn22
          }
        case 3:
          return {
            btn1: this.btn31,
            btn2: this.btn32
          }
        case 4:
          return {
            btn1: this.btn41,
            btn2: this.btn42
          }
        default:
          return {
            btn1: this.btn11,
            btn2: this.btn12
          }
      }
    },
    imgSrc () {
      switch (this.num) {
        case 1:
          return this.img1;
        case 2:
          return this.img2;
        case 3:
          return this.img3;
        case 4:
          return this.img4;
        default:
          return this.img1;
      }
    },
    infoSrc () {
      let preInfoNumber = `${this.num}${this.onClickNumber}`;
      preInfoNumber = Number(preInfoNumber);
      switch (preInfoNumber) {
        case 11:
          return {
            src1: this.imgSrc11,
            src2: this.imgSrc12,
          }
        case 12:
          return {
            src1: this.imgSrc21,
            src2: this.imgSrc22,
          }
        case 21:
          return {
            src1: this.imgSrc31,
            src2: this.imgSrc32,
          }
        case 22:
          return {
            src1: this.imgSrc41,
            src2: this.imgSrc42,
          }
        case 31:
          return {
            src1: this.imgSrc51,
            src2: this.imgSrc52,
          }
        case 32:
          return {
            src1: this.imgSrc61,
            src2: this.imgSrc62,
          }
        case 41:
          return {
            src1: this.imgSrc71,
            src2: this.imgSrc72,
          }
        case 42:
          return {
            src1: this.imgSrc81,
            src2: this.imgSrc82,
          }
        default:
          return {
            src1: this.imgSrc11,
            src2: this.imgSrc12,
          }
      }
    }
  },
  methods: {
    clickLeft () {
      this.onClickNumber = 1;
      this.isInfoShow = true;
    },
    clickRight () {
      this.onClickNumber = 2;
      this.isInfoShow = true;
    },
    crossIt () {
      this.isInfoShow = false;
      this.$emit('crossIt');
      console.log('cross prompt');
    }
  }
}
</script>

<style lang="less" scoped>
.p-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: 50%;
  margin-left: -10.375rem /* 166/16 */;
  bottom: 6%;
  width: 20.75rem /* 332/16 */;
  height: 24.8125rem /* 397/16 */;
  background-image: url('./prompt-container.png');
  background-size: cover;
  background-repeat: no-repeat;
  .pc-img-wrapper {
    position: absolute;
    top: 6.25rem /* 100/16 */;
    left: 1.875rem /* 30/16 */;
    .pc-desc {
      height: 12.125rem /* 194/16 */;
    }
  }
  .pc-btn {
    position: absolute;
    bottom: 1.875rem /* 30/16 */;
    img {
      width: 10.1875rem /* 163/16 */;
    }
    .pcb-l {
      position: relative;
      transform: translateX(10px);
    }
    .pcb-r {
      position: relative;
      transform: translateX(-10px);
    }
  }
}
.info-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 2.5rem /* 40/16 */;
  left: 50%;
  transform: translateX(-10.5625rem /* 169/16 */);
  box-sizing: border-box;
  width: 21.125rem /* 338/16 */;
  padding: 1.875rem /* 30/16 */ 3.125rem /* 50/16 */;
  background-color: #fff;
  border-radius: .5rem /* 8/16 */;
  .ip-ani {
    width: 18.75rem /* 300/16 */;
    height: 15.625rem /* 250/16 */;
  }
  .ip-desc {
    margin-top: .5rem;
    width: 16.5625rem /* 265/16 */;
  }
  .ip-cross {
    margin-top: .5rem;
    width: 1.75rem /* 28/16 */;
  }
}

.slideIn {
  animation: slideIn .5s linear;
  animation-fill-mode: both;
}

@keyframes slideIn {
  from {
    opacity: .2;
  }
  to {
    opacity: 1;
  }
}
</style>
